import { GeneralStyle } from '@website-builder/model/style/general-style';

export class IconStyle extends GeneralStyle {
  color = '';
  style = '';
  decoration = '';
  decorationColor = '';
  hoverColor = '';

  static normalize(styles: Partial<IconStyle>): IconStyle {
    const generalStyle = GeneralStyle.normalize(styles);
    const pureStyles = new IconStyle();

    Object.assign(pureStyles, generalStyle);

    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.style = styles.style ?? pureStyles.style;
    pureStyles.decoration = styles.decoration ?? pureStyles.decoration;
    pureStyles.decorationColor = styles.decorationColor ?? pureStyles.decorationColor;
    pureStyles.hoverColor = styles.hoverColor ?? pureStyles.hoverColor;

    return pureStyles;
  }
}
